import { Card, styled } from '@mui/material'

const CardContainer = styled(Card)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  padding: theme.spacing(3),
  boxShadow: '4px 6px 20px rgb(0 0 0 / 10%)',
  borderRadius: 24,
  [theme.breakpoints.down('sm')]: {
    borderRadius: 0,
    padding: theme.spacing(0),
    backgroundColor: 'transparent',
    boxShadow: 'none !important'
  }
}))

export default CardContainer
